<template>
    <VideoPageNotFound
        v-if="!['in-review', 'published'].includes(videoStatus)"
        :logged-in="authStore.loggedIn"
    />
    <VideoPageReviewed
        v-else-if="canReviewStatus === 'REVIEW_SUBMITTED' && authStore.loggedIn"
    />
    <VideoPagePeersReviewing
        v-else-if="['MISSING_PARAMETERS', 'REVIEW_NOT_ALLOWED'].includes(canReviewStatus)"
        :logged-in="authStore.loggedIn"
    />
    <VideoPageLoggedOut
        v-else-if="!authStore.loggedIn"
    />
    <VideoPageLoggedIn
        v-else-if="['VIDEO_PUBLISHED', 'REVIEW_AWAITING'].includes(canReviewStatus)"
        :review-status="canReviewStatus"
    />
    <div
        v-else
        class="video-page"
    >
        Not found
    </div>
</template>

<script setup>
import CanReviewQuery from '~/graphql/queries/canReview.graphql';
import { useAuthStore } from '~/store/auth';

const authStore = useAuthStore();
const route = useRoute();
const variables = { slug: route.params.slug[0] };

const { data } = await useAsyncQuery({
    query: CanReviewQuery,
    variables
});

const canReviewStatus = computed(() => data.value?.canReview?.message);
const videoStatus = computed(() => data.value?.video?.status);
</script>

<style lang="less">

</style>
